<div nxLayout="grid maxwidth" class="home" *ngIf="loggedUser.authenticated">
    <div nxRow>
        <div nxCol="12" class="docs-grid-colored-col">
            <div class="page-index">
                <h3 nxHeadline="subsection-large"><b><span translate
                            [translateParams]="{name: welcomeName}">{{ 'home.greet.'+loggedUser.role }}</span></b>
                </h3>
                <h4 nxHeadline="subsection-medium" translate>{{ 'home.welcome-message.'+loggedUser.role }}</h4>
            </div>
            <ng-container [ngSwitch]="loggedUser.role">
                <app-home-individual *ngSwitchCase="commonService.userRoles.Individual">
                    <app-call-me-back></app-call-me-back>
                    <app-preffered-agent></app-preffered-agent>
                </app-home-individual>
                <app-home-legal-person *ngSwitchCase="commonService.userRoles.LegalPerson">
                </app-home-legal-person>
                <app-home-b2b-lease *ngSwitchCase="commonService.userRoles.B2BLease"></app-home-b2b-lease>
            </ng-container>
        </div>
    </div>
</div>